import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../../ts/ServerApi/types/actionParams';
import { DatabaseAllowedActions } from '../../types/DatabaseAllowedActions';

export class GetDatabaseActionsRequest extends Request<ISingleIdParams, DatabaseAllowedActions> {
  constructor(id: string) {
    super('getDatabaseActions', { id: id });
  }
}
